import { slicedToArray as _slicedToArray } from './_virtual/_rollupPluginBabelHelpers.esm.js';
import { useRef, useCallback, useEffect } from 'react';
import useBoolean from './use-boolean.esm.js';

function useHover(options) {
  var _ref = options || {},
    dom = _ref.dom,
    onEnter = _ref.onEnter,
    onLeave = _ref.onLeave;
  var element = useRef(null);
  var onEnterRef = useRef(onEnter);
  onEnterRef.current = onEnter;
  var onLeaveRef = useRef(onLeave);
  onLeaveRef.current = onLeave;
  var _useBoolean = useBoolean(),
    _useBoolean2 = _slicedToArray(_useBoolean, 2),
    state = _useBoolean2[0],
    setHovered = _useBoolean2[1];
  var onMouseEnter = useCallback(function () {
    // eslint-disable-next-line no-console
    // console.log(`useHover onMouseEnter`)
    if (onEnterRef.current) onEnterRef.current();
    setHovered.on();
  }, [setHovered]);
  var onMouseLeave = useCallback(function () {
    // eslint-disable-next-line no-console
    // console.log(`useHover onMouseLeave`)
    if (onLeaveRef.current) onLeaveRef.current();
    setHovered.off();
  }, [setHovered]);
  useEffect(function () {
    // eslint-disable-next-line no-console
    // console.log(`useHover add listener`)
    var passedInElement = typeof dom === 'function' ? dom() : dom;
    // 如果 传入dom
    if (passedInElement) {
      passedInElement.addEventListener('mouseenter', onMouseEnter);
      passedInElement.addEventListener('mouseleave', onMouseLeave);
      return function () {
        passedInElement.removeEventListener('mouseenter', onMouseEnter);
        passedInElement.removeEventListener('mouseleave', onMouseLeave);
      };
    }
    var node = element.current;
    if (node) {
      node.addEventListener('mouseenter', onMouseEnter);
      node.addEventListener('mouseleave', onMouseLeave);
      return function () {
        node.removeEventListener('mouseenter', onMouseEnter);
        node.removeEventListener('mouseleave', onMouseLeave);
      };
    }
    return;
  }, [element, dom, onMouseLeave, onMouseEnter]);
  if (dom) {
    return [!!state];
  }
  return [!!state, element];
}

export { useHover as default };
//# sourceMappingURL=use-hover.esm.js.map
